import { render, staticRenderFns } from "./deleteconfirmation.vue?vue&type=template&id=9e3c5204"
import script from "./deleteconfirmation.vue?vue&type=script&lang=js"
export * from "./deleteconfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports